export default "__VITE_ASSET__XYKusaPH__"